import React, { useEffect, useState } from 'react';

import { Button, intl, TextInput } from 'ehs-react';
import { useViewStateStore } from '../../stores/viewState.store';
import { InstitutionHeader } from '../Header/InstitutionHeader';
import { usePortletStore } from '../../App';

export function ConnectAppointment(): JSX.Element {
  const [
    appointmentMode,
    reconnectSessionMode,
    institution
  ] = useViewStateStore(store => [
    store.viewStateData?.appointmentMode,
    store.viewStateData?.reconnectSessionMode,
    store.viewStateData?.selectedInstitution
  ]);

  let theView = <div>Unkown view</div>;
  if (appointmentMode) {
    theView = <Appointment />;
  } else if (reconnectSessionMode) {
    theView = <Reconnect />;
  }

  return (
    <>
      <InstitutionHeader institution={institution} />
      {theView}
    </>
  );
}

function Appointment(): JSX.Element {
  const [nextDisabled, setNextDisabled] = useState(true);

  const [
    appointmentId,
    setAppointmentId,
    nextState,
    previousState
  ] = useViewStateStore(state => [
    state.viewStateData?.appointmentId,
    state.setAppointmentId,
    state.nextState,
    state.previousState
  ]);

  useEffect(() => {
    setNextDisabled(!appointmentId || appointmentId === '');
  }, [appointmentId]);

  return (
    <>
      <div className="vvpp-content">
        <h3 className="vvpp-reconnect-appointment-info">
          {intl('virtualvisitpatientportlet.appointment.label')}
        </h3>
        <TextInput
          type="text"
          label={intl(
            'virtualvisitpatientportlet.appointment.input.placeholder'
          )}
          required
          onChange={setAppointmentId}
          value={appointmentId}
        />
      </div>
      <div className="vvpp-multi-buttons vvpp-buttons-separator">
        <Button
          variant="gray"
          disabled={false}
          onClick={previousState}
          text={intl('view.button.back')}
        />
        <Button
          variant="primary"
          disabled={nextDisabled}
          onClick={nextState}
          text={intl('view.button.next')}
        />
      </div>
    </>
  );
}

function Reconnect(): JSX.Element {
  const [nextDisabled, setNextDisabled] = useState(true);

  const [
    accessCode,
    setAccessCode,
    idNumber,
    setIdentificationNumber,
    familyName,
    setFamilyName,
    nextState,
    previousState
  ] = useViewStateStore(state => [
    state.viewStateData?.queueId,
    state.setAccessCode,
    state.viewStateData?.patientData?.patientIdentificator,
    state.setIdentificationNumber,
    state.viewStateData?.patientData?.familyName,
    state.setFamilyName,
    state.nextState,
    state.previousState
  ]);
  const [mandatoryFieldForRegistration] = usePortletStore(state => [
    state.configuration.registrationConfig.mandatoryFieldForRegistration
  ]);
  const isIdentificationMandatory =
    mandatoryFieldForRegistration === 'IDENTIFICATION' ? true : false;
  const isLastNameMandatory =
    mandatoryFieldForRegistration === 'LAST_NAME' ? true : false;
  useEffect(() => {
    if (isIdentificationMandatory) {
      setNextDisabled(
        !accessCode || !idNumber || accessCode === '' || idNumber === ''
      );
    } else if (isLastNameMandatory) {
      setNextDisabled(
        !accessCode || !familyName || accessCode === '' || familyName === ''
      );
    }
  }, [
    accessCode,
    idNumber,
    familyName,
    isIdentificationMandatory,
    isLastNameMandatory
  ]);

  return (
    <>
      <div className="vvpp-content">
        <h3 className="vvpp-reconnect-appointment-info">
          {isIdentificationMandatory &&
            intl('virtualvisitpatientportlet.reconnectsession.label.1.id')}
          {isLastNameMandatory &&
            intl(
              'virtualvisitpatientportlet.reconnectsession.label.1.last.name'
            )}

          <br />
          {intl('virtualvisitpatientportlet.reconnectsession.label.2')}
        </h3>
        <TextInput
          type="text"
          label={intl(
            'virtualvisitpatientportlet.reconnectsession.waiting.input.placeholder'
          )}
          required
          onChange={setAccessCode}
          value={accessCode || ''}
        />{' '}
        {isIdentificationMandatory && (
          <TextInput
            type="text"
            label={intl('virtualvisitpatientportlet.identification.number')}
            required
            onChange={setIdentificationNumber}
            value={idNumber || ''}
          />
        )}
        {isLastNameMandatory && (
          <TextInput
            type="text"
            label={intl('common.name.family')}
            required
            onChange={setFamilyName}
            value={familyName || ''}
          />
        )}
      </div>
      <div className="vvpp-multi-buttons vvpp-buttons-separator">
        <Button
          variant="gray"
          disabled={false}
          onClick={previousState}
          text={intl('view.button.back')}
        />
        <Button
          variant="primary"
          disabled={nextDisabled}
          onClick={nextState}
          text={intl('view.button.next')}
        />
      </div>
    </>
  );
}
